import React, { useState } from "react";
import contactImage from "../assets/image/contact.png"; // Adjust with the correct image path

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData); // Here you can send the form data to backend or email service
  };

  return (
    <div
      style={{
        fontFamily: "'Open Sans', sans-serif",
        color: "#333",
        backgroundColor: "#f9f9f9",
        padding: "50px 20px",
      }}
    >
      <header
        style={{
          backgroundColor: "#007bff",
          color: "white",
          textAlign: "center",
          padding: "50px 20px",
          borderRadius: "10px",
          marginBottom: "40px",
        }}
      >
        <h1
          style={{
            fontSize: "42px",
            fontWeight: "bold",
            marginBottom: "10px",
            textTransform: "uppercase",
          }}
        >
          Get in Touch
        </h1>
        <p
          style={{
            fontSize: "18px",
            margin: "0 auto",
            maxWidth: "600px",
            fontWeight: "normal",
          }}
        >
          We’d love to hear from you! Contact us with your queries, suggestions,
          or feedback, and our team will get back to you promptly.
        </p>
      </header>

      {/* Main Section */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 2fr",
          gap: "30px",
          marginBottom: "40px",
        }}
      >
        {/* Reach Us At Section */}
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <img
            src={contactImage}
            alt="Contact Us"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "10px",
              marginBottom: "20px",
              transition: "transform 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          />
          <h2 style={{ fontSize: "24px", color: "#007bff", marginBottom: "20px" }}>
            Reach Us At
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "10px" }}>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:info@atlastradecenter.lk"
              style={{ color: "#007bff", textDecoration: "none" }}
            >
              info@atlastradecenter.lk
            </a>
          </p>
          <p style={{ fontSize: "16px", marginBottom: "10px" }}>
            <strong>Phone:</strong> +94 11 2 399399
          </p>
          <p style={{ fontSize: "16px" }}>
            <strong>Address:</strong> 
            <hr></hr>
            <br></br>Atlas Trade Center,
             <br></br>H K Dharmadasa Mawatha,
             <br></br>Colombo 02,
             <br></br>Sri Lanka
          </p>
        </div>

        {/* Right Side: Send Us a Message and Find Us Here */}
        <div>
          {/* Send Us a Message */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
              marginBottom: "30px",
            }}
          >
            <h2
              style={{
                fontSize: "24px",
                color: "#007bff",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              Send Us a Message
            </h2>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <label
                  htmlFor="name"
                  style={{
                    display: "block",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    padding: "12px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                    outline: "none",
                    transition: "border-color 0.3s ease",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#007bff")}
                  onBlur={(e) => (e.target.style.borderColor = "#ddd")}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  htmlFor="email"
                  style={{
                    display: "block",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  Your Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    padding: "12px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                    outline: "none",
                    transition: "border-color 0.3s ease",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#007bff")}
                  onBlur={(e) => (e.target.style.borderColor = "#ddd")}
                />
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  htmlFor="message"
                  style={{
                    display: "block",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "5px",
                  }}
                >
                  Your Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  style={{
                    width: "100%",
                    padding: "12px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                    outline: "none",
                    minHeight: "120px",
                    resize: "vertical",
                    transition: "border-color 0.3s ease",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#007bff")}
                  onBlur={(e) => (e.target.style.borderColor = "#ddd")}
                ></textarea>
              </div>

              <button
                type="submit"
                style={{
                  width: "100%",
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "12px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#0056b3")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#007bff")}
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Find Us Here */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2
              style={{
                fontSize: "24px",
                color: "#007bff",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              Find Us Here
            </h2>
            <div
              style={{
                width: "100%",
                height: "300px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <iframe
                title="Atlas Trade Center Location"
                src="https://www.google.com/maps/embed?pb=..."
                width="100%"
                height="300"
                frameBorder="0"
                style={{ border: "0", borderRadius: "10px" }}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Responsiveness with Media Queries */}
      <style>{`
        @media (max-width: 768px) {
          .contact-page-container {
            padding: 20px;
          }
          .contact-form, .find-us-container {
            margin-bottom: 20px;
          }
          .contact-header h1 {
            font-size: 32px;
          }
          .contact-header p {
            font-size: 16px;
          }
          .grid {
            display: block;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactPage;
